import { font, fontFamily } from '../partners/tokens'

export const fontSizes = {
  xxs: 10,
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 30,
  '4xl': 36,
  '5xl': 48,
  '6xl': 60,
  '7xl': 72,
  '8xl': 96,
  '9xl': 128,
}

export const fontConfig = {
  [fontFamily]: {
    400: {
      normal: `${fontFamily}`,
    },
    700: {
      normal: `${fontFamily}-Bold`,
    },
  },
  SansSerif: {
    400: {
      normal: 'sans-serif',
    },
  },
}

export const fonts = {
  heading: font,
  body: font,
}
